<template>
	<article class="report">
		<PageHeader class="report__header">
			<p class="report__count-info">{{ countInfo }}</p>
		</PageHeader>
		<ManagingSection :isTable="true">
			<HorizontalSearch
				:blockElem="true"
				class="search-by-enter__container"
				@search="search"
				@init="initPage"
			>
				<SelectInput
					ref="searchType"
					:selectList="searchTypeList"
					:defaultSelectValue="searchType"
					placeholder="입력하세요"
					@change="searchTypeChange"
				/>
				<SelectInput
					ref="at"
					:usePeriod="true"
					:defaultSelectValue="at"
					:selectList="atList"
					@change="atChange"
				/>
				<InputText
					:propValue="brandTitle"
					prevLabel="브랜드명"
					ver="3"
					:inputWidth="140"
					@input="value => (brandTitle = value)"
				/>
				<InputText
					:propValue="writerNickName"
					prevLabel="리뷰어"
					ver="3"
					:inputWidth="140"
					@input="value => (writerNickName = value)"
				/>
			</HorizontalSearch>
		</ManagingSection>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<span class="section__info__left"></span>
				<div class="section__info__right">
					<button
						@click="toNormalBatch(itemCheck)"
						class="btn blue report__table-side"
						v-text="'일괄 정상처리'"
					/>
					<button
						@click="toBlindBatch(itemCheck)"
						class="btn orange report__table-side"
						v-text="'일괄 블라인드처리'"
					/>
					<Selector
						v-if="reasonList"
						v-model="reportReasonValueCode"
						title="신고사유"
						:option-list="reasonList"
						:isV3="true"
						@input="reportReasonValueCodeInput"
						class="report__table-side"
					/>
					<Selector
						v-model="state"
						title="처리상태"
						:option-list="stateList"
						:isV3="true"
						value-key="id"
						@input="stateInput"
						class="report__table-side"
					/>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th class="report__checkbox-cell">
							<input
								v-model="allCheckModel"
								:value="allCheck"
								type="checkbox"
								class="report__checkbox"
							/>
						</th>
						<th class="report__no-cell" v-text="'No'" />
						<th class="report__date-cell" v-text="'접수일'" />
						<th class="report__product-cell" v-text="'제품명'" />
						<th v-text="'리뷰 본문'" />
						<th class="report__reviewer-cell" v-text="'리뷰어'" />
						<th class="report__type-cell" v-text="'신고사유'" />
						<th class="report__reporter-cell" v-text="'신고자'" />
						<th class="report__state-cell" v-text="'리뷰상태'" />
						<th class="report__state-cell" v-text="'처리상태'" />
						<th class="report__date-cell" v-text="'처리일'" />
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in list" :key="item.id">
						<td class="report__checkbox-cell">
							<input
								v-if="item.idreviewcomment"
								v-model="itemCheckModel"
								:value="item.id"
								type="checkbox"
								class="report__checkbox"
							/>
						</td>
						<td class="report__no-cell" v-text="item.id" />
						<td
							class="report__date-cell"
							v-text="item.parsedCreatedAt"
						/>
						<td>
							<template v-if="item.productTitle">
								<a
									:href="`${$store.state.env.adminDomain}/brand/${item.idBrand}`"
									class="link"
									v-text="`[${item.name}]`"
								/>
								<br />
								<router-link
									:to="`/product/product-inquiry/${item.idProduct}`"
									class="link"
									>{{ item.productTitle }}</router-link
								>
							</template>
							<template v-else>-</template>
						</td>
						<td class="text-left">
							<router-link
								:to="`/review/${item.idreviewcomment}`"
								class="link report__review-text"
								>{{ item.reviewText }}</router-link
							>
						</td>
						<td class="report__reviewer-cell">
							<router-link
								:to="`/register/register-info/${item.writerIdRegister}`"
								class="link"
								>{{ item.writerNickName }}</router-link
							>
						</td>
						<td class="report__type-cell">
							<router-link
								class="link"
								:to="`/review/report/${item.id}`"
								>{{ item.reportReasonValueName }}</router-link
							>
						</td>
						<td class="report__reporter-cell">
							<router-link
								class="link"
								:to="`/register/register-info/${item.reporterIdRegister}`"
								target="_blank"
								>{{ item.reporterNickName }}</router-link
							>
						</td>
						<td
							class="report__state-cell"
							v-text="item.reviewStateName"
						/>
						<td
							class="report__state-cell"
							v-text="item.stateName"
						/>
						<td
							class="report__date-cell"
							v-text="item.parsedUpdatedAt"
						/>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				:total-item="contentTotal"
				:limit="limit"
				:offset="offset"
				@to="paging"
			/>
		</ManagingSection>
	</article>
</template>
<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import HorizontalSearch from '@/components/HorizontalSearch.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import InputText from '@/components/InputText.vue';
	import Selector from '@/components/Selector.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';

	export default {
		name: 'ReviewReportList',
		components: {
			PageHeader,
			ManagingSection,
			HorizontalSearch,
			SelectInput,
			InputText,
			Selector,
			PaginationBox,
		},
		extends: SearchByEnter,
		data() {
			return {
				reportReviewCount: null,
				searchTypeList: [
					{ value: 'reporterNickName', name: '신고자' },
					{ value: 'productTitle', name: '제품명' },
				],
				searchType: 'reporterNickName',
				reporterNickName: '',
				productTitle: '',
				atList: [
					{ value: 'created', name: '접수일' },
					{ value: 'updated', name: '처리일' },
				],
				at: 'created',
				AtMin: '',
				AtMax: '',
				brandTitle: '',
				writerNickName: '',
				contentTotal: 0,
				reportReasonValueCode: null,
				state: null,
				list: null,
				limit: 50,
				offset: 0,
				allCheck: false,
				itemCheck: [],
			};
		},
		computed: {
			countInfo() {
				const count = this.reportReviewCount;
				if (!count) return '';
				return `총 등록 (${Number(count.totalCount)}) ㅣ 대기 (${Number(count.waitCount)}) ㅣ 완료 (${Number(count.completedCount)}) ㅣ 보류 (${Number(count.holdCount)})`;
			},
			...mapGetters({
				reasonList: 'notice/reasonList',
				getListAddNull: 'getListAddNull',
			}),
			reviewStateList() {
				// 리뷰 상태
				return this.getListAddNull(
					'reviewCommentState',
					null,
					'리뷰삭제'
				);
			},
			stateList() {
				// 처리 상태
				return this.getListAddNull('reportReviewState');
			},
			allCheckModel: {
				get() {
					return this.allCheck;
				},
				set(allCheck) {
					this.allCheck = allCheck;
					this.itemCheck = allCheck
						? this.list.map(item => item.id)
						: [];
				},
			},
			itemCheckModel: {
				get() {
					return this.itemCheck;
				},
				set(checkList) {
					this.itemCheck = checkList;
					this.allCheck = checkList.length === this.list.length;
				},
			},
		},
		watch: {
			'$route.query'() {
				this.getNoticeList();
			},
		},
		async mounted() {
			if (!this.reasonList) {
				await this.$store.dispatch('notice/init');
			}
			this.setFilter();
			this.getNoticeList();
		},
		methods: {
			setQuery() {
				const query = {
					offset: String(this.offset),
					limit: String(this.limit),
				};
				if (this.reporterNickName || this.productTitle) {
					query[this.searchType] = this[this.searchType];
				}
				if (this.at) {
					query.at = this.at;
				}
				if (this.AtMin) {
					query.AtMin = this.AtMin;
				}
				if (this.AtMax) {
					query.AtMax = this.AtMax;
				}
				if (this.reportReasonValueCode) {
					query.reportReasonValueCode = this.reportReasonValueCode;
				}
				if (this.state) {
					query.state = this.state;
				}
				if (this.brandTitle) {
					query.brandTitle = this.brandTitle;
				}
				if (this.writerNickName) {
					query.writerNickName = this.writerNickName;
				}
				this.$router.replace({ query }).catch(() => {
					window.location.reload();
				});
			},
			initPage() {
				this.searchType = this.searchTypeList[0].value;
				this.reporterNickName = '';
				this.productTitle = '';
				this.at = this.atList[0].value;
				this.AtMin = '';
				this.AtMax = '';
				this.$refs.searchType.init();
				this.$refs.at.init();
				this.reportReasonValueCode = null;
				this.state = null;
				this.offset = 0;
				this.brandTitle = '';
				this.writerNickName = '';
				this.setQuery();
			},
			searchTypeChange({ select, input }) {
				this.searchType = select;
				this[select] = input;
			},
			atChange({ select, from, to }) {
				this.at = select;
				this.AtMin = from ? moment(from, 'YYYY-MM-DD').format('x') : '';
				this.AtMax = to
					? moment(to, 'YYYY-MM-DD').endOf('date').format('x')
					: '';
			},
			reportReasonValueCodeInput() {
				this.search();
			},
			stateInput() {
				this.search();
			},
			paging({ offset }) {
				this.search(offset);
			},
			search(offset = 0) {
				this.offset = offset;
				this.setQuery();
			},
			setFilter() {
				const {
					reporterNickName,
					productTitle,
					at,
					AtMin,
					AtMax,
					reportReasonValueCode,
					state,
					offset,
					limit,
					brandTitle,
					writerNickName,
				} = this.$route.query;
				if (reporterNickName) {
					this.$refs.searchType.selectModel = this.searchType =
						'reporterNickName';
					this.$refs.searchType.inputModel = this.reporterNickName =
						reporterNickName;
				} else if (productTitle) {
					this.$refs.searchType.selectModel = this.searchType =
						'productTitle';
					this.$refs.searchType.inputModel = this.productTitle =
						productTitle;
				}
				if (at) {
					this.at = at;
				}
				if (AtMin || AtMax) {
					this.$refs.at.selectModel = this.at = at;
					this.$refs.at.changePeriod({
						from: AtMin
							? moment(AtMin, 'x').format('YYYY-MM-DD')
							: '',
						to: AtMax
							? moment(AtMax, 'x').format('YYYY-MM-DD')
							: '',
					});
				}
				if (reportReasonValueCode) {
					this.reportReasonValueCode = reportReasonValueCode;
				}
				if (state) this.state = state;
				if (offset) this.offset = Number(offset);
				if (limit) this.limit = Number(limit);
				if (brandTitle) this.brandTitle = brandTitle;
				if (writerNickName) this.writerNickName = writerNickName;
			},
			async getNoticeList() {
				const params = {
					offset: this.offset,
					limit: this.limit,
				};
				if (this.reporterNickName || this.productTitle) {
					params[this.searchType] = this[this.searchType];
				}
				if (this.AtMin) {
					params[`${this.at}AtMin`] = this.AtMin;
				}
				if (this.AtMax) {
					params[`${this.at}AtMax`] = this.AtMax;
				}
				if (this.reportReasonValueCode) {
					params.reportReasonValueCode = this.reportReasonValueCode;
				}
				if (this.state) {
					params.state = this.state;
				}
				if (this.brandTitle) {
					params.brandTitle = this.brandTitle;
				}
				if (this.writerNickName) {
					params.writerNickName = this.writerNickName;
				}
				const { data } = await this.$axiosAdmin2.get(
					'/v3/api/review/report/list',
					{ params }
				);
				this.reportReviewCount = data.reportReviewCount;
				this.contentTotal = data.reportReviewList.contentTotal;
				this.list = data.reportReviewList.data.map(item => {
					item.productTitle = item.productTitle;
					item.parsedCreatedAt = moment(item.createdAt).format(
						'YYYY.MM.DD HH:mm:SS'
					);
					const reviewStateObj = this.reviewStateList.filter(
						reviewStateItem =>
							reviewStateItem.id === item.reviewCommentState
					)[0];
					item.reviewStateName = reviewStateObj
						? reviewStateObj.name
						: '-';
					const stateObj = this.stateList.filter(
						stateItem => stateItem.id === item.reportReviewState
					)[0];
					item.stateName = stateObj ? stateObj.name : '-';
					item.parsedUpdatedAt =
						item.reportReviewState === 'W' ||
						item.createdAt === item.updatedAt
							? '-'
							: moment(item.updatedAt).format(
									'YYYY.MM.DD HH:mm:SS'
								);
					return item;
				});
			},
			uniqReviewIdListFromReportIdList(reportIdList) {
				return reportIdList.reduce((acc, reportId) => {
					const idReview = this.list.find(
						item => item.id === reportId
					)?.idreviewcomment;
					if (idReview && acc.every(id => id !== idReview)) {
						acc.push(idReview);
					}
					return acc;
				}, []);
			},
			async batch(params) {
				try {
					await this.$axiosAdmin2.post(
						'/v3/api/review/report/bulk',
						params
					);
				} catch (err) {
					console.error(err);
					alert('일괄작업실패! 개발팀에 문의하세요.');
				}
			},
			async toNormalBatch(list) {
				if (
					(list.length &&
						!confirm('선택된 리뷰 모두 정상처리하시겠습니까?')) ||
					(!list.length &&
						!confirm(
							'리뷰를 선택하지 않으셨습니다. 현재 목록 모두 정상처리하시겠습니까?'
						))
				)
					return;
				await this.batch({
					idReviewCommentList: this.uniqReviewIdListFromReportIdList(
						list.length ? list : this.list.map(({ id }) => id)
					),
					reportReviewState: 'F',
					reviewCommentState: 'N',
				});
				this.allCheckModel = false;
				this.getNoticeList();
			},
			toBlindBatch(list) {
				if (!list.length) {
					if (
						!confirm(
							'리뷰를 선택하지 않으셨습니다. 현재 목록 모두 선택하시겠습니까?'
						)
					)
						return;
					list = this.list.map(({ id }) => id);
				}
				list = this.uniqReviewIdListFromReportIdList(list);
				this.$store.commit('modal/toggleModal', {
					id: 'ToBlindBatch',
					params: { list },
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.report {
		&__header {
			align-items: center;
		}

		&__count-info {
			line-height: 24px;
			font-size: 1rem;
		}

		&__table-side {
			margin-left: 14px;
		}

		&__checkbox-cell {
			width: 32px;
			padding-left: 0;
			padding-right: 0;
		}

		&__checkbox {
			cursor: pointer;
		}

		&__no-cell {
			width: 64px;
			padding-left: 0;
			padding-right: 0;
		}

		&__date-cell {
			width: 140px;
			padding-left: 0;
			padding-right: 0;
		}

		&__product-cell {
			width: 220px;
			padding-left: 0;
			padding-right: 0;
		}

		&__review-text {
			white-space: break-spaces;
		}

		&__reviewer-cell {
			width: 100px;
			padding-left: 0;
			padding-right: 0;
		}

		&__type-cell {
			width: 120px;
			padding-left: 0;
			padding-right: 0;
		}

		&__reporter-cell {
			width: 100px;
			padding-left: 0;
			padding-right: 0;
		}

		&__state-cell {
			width: 60px;
			padding-left: 0;
			padding-right: 0;
		}
	}
</style>
